import { render, staticRenderFns } from "./view.vue?vue&type=template&id=a0e3ff9c"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=a0e3ff9c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0e3ff9c')) {
      api.createRecord('a0e3ff9c', component.options)
    } else {
      api.reload('a0e3ff9c', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=a0e3ff9c", function () {
      api.rerender('a0e3ff9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/view.vue"
export default component.exports